export const SELECTED_TECHNIQUE_URL_PARAM = "technique-selector"
export const SELECTED_ROADWORK_URL_PARAM = "roadwork-selector"
